import { Box, Checkbox } from "@drone-js/core";
import { useOnboardingPageContextAtomValue } from "apps/oneOnboarding/onboardingPageContextAtom";
import { useFormContext } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";
import { useContractCheckboxValidation } from "./useContractCheckboxValidation";

export const BulkContractCheckboxController = () => {
    const { formState, setValue } = useFormContext<BulkPropertyFormData>();
    // contractDetail can transiently be null during page-context transitions
    // (e.g. when the publish save response targets the complete page, which
    // does not carry contract details). Default to an empty id so the brief
    // re-render before navigation does not crash.
    const { isInternalUser, contractDetail } = useOnboardingPageContextAtomValue();
    const id = contractDetail?.id ?? "";
    const { propertyDataList, isSelected } = useContractCheckboxValidation();

    const handleClick = () => {
        if (isInternalUser) return;

        propertyDataList.forEach((_, i) => {
            setValue(`propertyDataList.${i}.contractId`, !isSelected ? id : "");
        });
    };

    return (
        <Box onClick={handleClick} data-element-name="ack-terms-conditions" data-testid="ack-terms-conditions">
            <Checkbox
                selection={isSelected ? "selected" : "unselected"}
                state={formState.isLoading || isInternalUser ? "disabled" : "enabled"}
            />
        </Box>
    );
};
